import { render, staticRenderFns } from "./ActType.vue?vue&type=template&id=0349e898&"
import script from "./ActType.vue?vue&type=script&lang=js&"
export * from "./ActType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports